import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { roleLabel } from "@/lib/roles";

export default function MilestoneChangeLog({ projectId, refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get(`/milestones/changes?project_id=${projectId}`).then(r => setRows(r.data)).catch(() => setRows([]));
  }, [projectId, refreshKey]);
  return (
    <Card data-testid="ms-change-log">
      <CardContent className="p-3">
        <div className="text-xs font-semibold text-slate-600 mb-2">Change log ({rows.length})</div>
        {rows.length === 0 && <div className="text-xs text-slate-500">No changes recorded yet.</div>}
        <div className="max-h-72 overflow-y-auto divide-y">
          {rows.map(c => (
            <div key={c.id} className="py-1.5 text-xs" data-testid={`ms-change-${c.id}`}>
              <span className="font-mono text-slate-400">{(c.at || "").slice(0, 16).replace("T", " ")}</span>{" "}
              <b>{c.by_name}</b> <span className="text-slate-500">({roleLabel(c.by_role)})</span> {c.action}{" "}
              <span className="font-medium">“{c.item_title}”</span>
              {c.changes?.map((ch, i) => (
                <div key={i} className="ml-4 text-[11px] text-slate-600">{ch.field}: <span className="line-through text-slate-400">{ch.old || "—"}</span> → {ch.new || "—"}</div>
              ))}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
